import { useCallback } from 'react';
import { get, template, templateSettings } from 'lodash-es';

import { translations } from '~/translations';

export const useLanguage = (langCode: 'ua' | 'ru', basePath?: string) => {
  const t = useCallback(
    (path: string, options?: Record<string, string>) => {
      return translate(translations[langCode], basePath ? `${basePath}.${path}` : path, options);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [langCode]
  );

  return { translate: t };
};

export function translate(texts: (typeof translations)['ua'], path: string, options?: Record<string, string>) {
  let result = get(texts, path, path);

  if (options) {
    templateSettings.interpolate = /{([\s\S]+?)}/g;
    const compiled = template(result);
    result = compiled(options);
  }

  return result;
}
